import React from 'react';
import { BookOpenIcon, CalculatorIcon, GlobeIcon, BeakerIcon, PrinterIcon, FolderIcon, CheckCircleIcon } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: <CheckCircleIcon className="w-8 h-8 text-green-600" data-id="element-102" />,
    title: '1️⃣ Planificaciones Organizadas por Grado',
    desc: 'Contenidos estructurados para 1° a 6° grado.'
  }, {
    icon: <BookOpenIcon className="w-8 h-8 text-green-600" data-id="element-103" />,
    title: '2️⃣ Lengua',
    desc: 'Comprensión lectora, escritura, producción de textos, gramática y actividades prácticas.'
  }, {
    icon: <CalculatorIcon className="w-8 h-8 text-green-600" data-id="element-104" />,
    title: '3️⃣ Matemática',
    desc: 'Operaciones, resolución de problemas, lógica, práctica guiada y ejercicios listos.'
  }, {
    icon: <GlobeIcon className="w-8 h-8 text-green-600" data-id="element-105" />,
    title: '4️⃣ Ciencias Sociales',
    desc: 'Historia, geografía, ciudadanía y actividades contextualizadas.'
  }, {
    icon: <BeakerIcon className="w-8 h-8 text-green-600" data-id="element-106" />,
    title: '5️⃣ Ciencias Naturales',
    desc: 'Cuerpo humano, ambiente, seres vivos, experimentación y actividades aplicables.'
  }, {
    icon: <PrinterIcon className="w-8 h-8 text-green-600" data-id="element-107" />,
    title: '6️⃣ Actividades Prácticas Listas para Imprimir',
    desc: 'Ejercicios, propuestas dinámicas y recursos visuales.'
  }, {
    icon: <FolderIcon className="w-8 h-8 text-green-600" data-id="element-108" />,
    title: '7️⃣ Material Organizado por Área',
    desc: 'Todo clasificado por materia y grado.'
  }];
  return <section className="w-full bg-gray-50 py-10 px-4 md:px-8" data-id="element-109">
      <div className="max-w-5xl mx-auto" data-id="element-110">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-8" data-id="element-111">
          ¿QUÉ INCLUYE EL KIT COMPLETO PRIMARIA LISTA?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-112">
          {items.map((item, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-shadow flex gap-3 items-start" data-id="element-113">
              <div className="flex-shrink-0 mt-1" data-id="element-114">{item.icon}</div>
              <div data-id="element-115">
                <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-116">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-117">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}